import { number, object, oneOfType, shape, string } from "prop-types";
import { DATE_VARIANTS, formatDate } from "utils";

import classes from "./DocLastUpdatedCell.module.scss";

const DocLastUpdatedCell = ({ row }) => (
  <span
    className={classes["doc_last_updated_cell"]}
    data-testid="doc-last-updated-cell"
  >
    {formatDate(row.original.docLastUpdated, DATE_VARIANTS.DOT_TIME) || "-"}
  </span>
);

DocLastUpdatedCell.propTypes = {
  row: shape({
    id: oneOfType([number, string]),
    original: object,
  }),
};

export default DocLastUpdatedCell;
